export const ENV = { // Development
	wp_domain: 'https://app1.anticamente.com'
}


// WEBPACK FOOTER //
// ./src/environments/env.ts